import util from "../util";

let controller = "RelacaoOperadorPermissaoAnalise";

export default {
  GetAll: (dto, options) => {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  },
}